import {CountTriggerTextViewerCoreOption} from '../type/CountTriggerTextViewerCoreOption.interface';

export function getPageTextViewerSizes({
  size: {width, height},
  margin,
  isTwoColumnLayout,
  twoPagesGap,
}: CountTriggerTextViewerCoreOption) {
  const contentMargin = margin;

  // box-sizing 이 기본값인 content-box 라서 padding 을 포함합니다.
  // XXX: 추후 직관적이게 border-box 로 변경하고 사이즈 스트러지는 부분을 체크하면 좋겠습니다.
  const containerWidth = width - contentMargin * 2;
  const containerHeight = height - contentMargin * 2;

  const contentWidth = containerWidth;
  const contentHeight = containerHeight;

  const columnGap = Math.max(margin, twoPagesGap);
  const columnWidth = isTwoColumnLayout
    ? (contentWidth - columnGap) / 2
    : contentWidth;

  const onePageOffset = columnWidth + columnGap;

  return {
    contentMargin,
    containerWidth,
    containerHeight,
    contentWidth,
    contentHeight,
    columnWidth,
    columnGap,
    onePageOffset,
  };
}
